import { useQuery } from '@tanstack/react-query';
import { 
  getProcurementDamageReportData, 
  fetchSourceNames,
  type ProcurementDamageReportData,
  type SourceNameMap 
} from '@/services/procurementDamageReportService';

export function useProcurementDamageReport(startDate: Date, endDate: Date) {
  return useQuery<ProcurementDamageReportData>({
    queryKey: ['procurement-damage-report', startDate.toISOString(), endDate.toISOString()],
    queryFn: () => getProcurementDamageReportData(startDate, endDate),
  });
}

// Separate hook for lazy loading source names (suppliers/agents)
export function useSourceNames(enabled: boolean = false) {
  return useQuery<SourceNameMap>({
    queryKey: ['source-names-for-damage-report'],
    queryFn: fetchSourceNames,
    enabled, // Only fetch when explicitly enabled (tab switch)
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
